<template>
  <div class="carlist-con">
    <div class="top-con">
      <h3>{{$t('VehicleManagement')}}</h3>
      <div class="search-time-con">
        <div class="l">{{$t('VisitDate')}}</div>
        <div class="c">
          <dateTimePicker
            :type="'date'"
            v-model="TargetDate"
            :placeholder="$t('PleaseSelectTime')"
            @change="handleDateChange"
            :hasclass="'no-style'"
          ></dateTimePicker>
        </div>
        <div class="r">
          <div class="button" @click="search">{{$t('Search')}}</div>
        </div>
      </div>
    </div>
    <div class="tab">
      <div class="row">
        <div class="col-4" v-for="(item, index) in date" :key="item.name">
          <span :class="activeIndex == index ? 'active button': 'button'" @click="showItem(index)">
            {{item.name}}
            <span v-if="index==0">({{total1}})</span>
            <span v-else-if="index==1">({{total2}})</span>
            <span v-else>({{total3}})</span>
          </span>
        </div>
      </div>
    </div>
    <div class="content">
      <div
        class="list"
        v-for="(item, index) in activeList"
        :key="item.scheduleName + item.dockName"
      >
        <div class="title" @click="toggle(item, index)">
          {{item.dockName}} ({{item.total}})
          <i
            class="iconfont icon-down"
            v-if="item.noVisit.length || item.visiting.length || item.leave.length"
          ></i>
        </div>
        <div v-show="item.show">
          <div class="list-con" v-if="item.noVisit.length">
            <div class="sub-title">{{$t('FutureVisit')}} ({{item.noVisit.length}})</div>
            <div
              class="list-info"
              v-for="(car, index) in item.noVisit"
              :key="'noVisit'+index"
            >{{car.carInfo}} {{car.visitTime}}</div>
          </div>
          <div class="list-con" v-if="item.visiting.length">
            <div class="sub-title">{{$t('Visiting')}} ({{item.visiting.length}})</div>
            <div
              class="list-info"
              v-for="(car, index) in item.visiting"
              :key="'visiting'+index"
            >{{car.carInfo}} {{car.visitTime}}</div>
          </div>
          <div class="list-con" v-if="item.leave.length">
            <div class="sub-title">{{$t('HadLeft')}} ({{item.leave.length}})</div>
            <div
              class="list-info"
              v-for="(car, index) in item.leave"
              :key="'leave'+index"
            >{{car.carInfo}} {{car.visitTime}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="go-top" @click="goTop" v-show="showGoTop">
      <i class="iconfont icon-up"></i>
    </div>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
    <div class="row fixed-con">
      <div class="col-4">
        <router-link to="/carrier/invitationlist/0">
          <span>{{$t('approvaling')}}</span>
        </router-link>
      </div>
      <div class="col-4 c">
        <router-link to="/carrier/invitationlist/1">
          <span>{{$t('approved')}}</span>
        </router-link>
      </div>
      <div class="col-4">
        <router-link to="/carrier/carlist">
          <span>{{$t('VehicleManagement')}}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { GetDockcarinfo } from "@/utils/api";
import { checkNested } from "@/utils/utils";
import Loading from "vue-loading-overlay";
import dateTimePicker from "@/components/dateTimePicker.vue";
export default {
  components: {
    Loading,
    dateTimePicker
  },
  data() {
    return {
      TargetDate: "",
      isLoading: false,
      mList: [],
      aList: [],
      eList: [],
      activeList: [],
      date: [
        { id: 1, name: this.$t("morning") },
        { id: 2, name: this.$t("Afternoon") },
        { id: 3, name: this.$t("AtNight") }
      ],
      activeIndex: 0,
      total1: 0,
      total2: 0,
      total3: 0,
      showGoTop: false
    };
  },
  created() {
    let date = new Date();
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() + " ";
    const currentDate = Y + M + D;
    this.getDockcarinfo(currentDate);
  },
  updated() {
    if (
      document.body.clientHeight - 200 >
      document.documentElement.clientHeight
    ) {
      this.showGoTop = true;
    } else {
      this.showGoTop = false;
    }
  },
  
  methods: {
    toggle: function(item, index) {
      item.show = !item.show;
      this.$set(this.activeList, index, item);
    },
    computedData(dataTotal) {
      dataTotal.forEach((item, index) => {
        let a = item.carList.filter(o => o.visitStatus === 1 );
        let b = item.carList.filter(o => o.visitStatus === 2);
        let c = item.carList.filter(o => o.visitStatus === 3);

        item.noVisit = a;
        item.visiting = b;
        item.leave = c;

        let ArrAll = [];
        a.forEach(obj => {
          ArrAll.push({
            ticketId: obj.ticketId,
            carNumber: obj.carNumber
          })
        });
        b.forEach(obj => {
          let data = {
            ticketId: obj.ticketId,
            carNumber: obj.carNumber
          }
          if (JSON.stringify(ArrAll).indexOf(JSON.stringify(data)) == -1) {
            ArrAll.push(data);
          }
        });
        c.forEach(obj => {
          let data = {
            ticketId: obj.ticketId,
            carNumber: obj.carNumber
          }
          if (JSON.stringify(ArrAll).indexOf(JSON.stringify(data)) == -1) {
            ArrAll.push(data);
          }
        });
        item.total = ArrAll.length;
      });
    },
    getDockcarinfo(date) {
      this.isLoading = true;
      GetDockcarinfo(date)
        .then(res => {
          if (checkNested(res, "data", "content", "model")) {
            this.isLoading = false;
            const totalData = res.data.content.model;
            this.mList = [];
            this.aList = [];
            this.eList = [];
            totalData.forEach(item => {
              if (item.scheduleId == "1") {
                this.mList.push(item);
              } else if (item.scheduleId == "2") {
                this.aList.push(item);
              } else {
                this.eList.push(item);
              }
            });
            
            this.computedData(this.mList);
            this.computedData(this.aList);
            this.computedData(this.eList);
            let total1 = 0,
              total2 = 0,
              total3 = 0;
            this.mList.forEach(item => {
              total1 = total1 + item.total;
              item.show = true;
            });
            this.aList.forEach(item => {
              total2 = total2 + item.total;
              item.show = true;
            });
            this.eList.forEach(item => {
              total3 = total3 + item.total;
              item.show = true;
            });
            this.total1 = total1;
            this.total2 = total2;
            this.total3 = total3;

            this.activeList = this.mList;
            this.activeIndex = 0;
          } else {
            this.$router.push({ path: "/noRecord" });
          }
        })
        .catch(err => {
          this.$router.push({ path: "/noRecord" });
        });
    },
    search() {
      if (this.TargetDate) {
        this.getDockcarinfo(this.TargetDate);
      }
    },
    handleDateChange() {},
    goTop() {
      window.scroll(0, 0);
    },
    showItem(index) {
      this.activeIndex = index;
      switch (index) {
        case 0:
          this.activeList = this.mList;
          break;
        case 1:
          this.activeList = this.aList;
          break;
        case 2:
          this.activeList = this.eList;
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.carlist-con {
  padding-bottom: 47px;
}
.go-top {
  width: 40px;
  height: 40px;
  color: #fff;
  text-align: center;
  background-image: linear-gradient(73deg, #f36443, #e42029);
  border-radius: 50%;
  line-height: 40px;
  position: fixed;
  right: 20px;
  bottom: 60px;
  .iconfont {
    font-size: 10px;
    line-height: 40px;
    vertical-align: top;
  }
}
.fixed-con {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 48px;
  border-top: 1px solid #ccc;
  margin: 0;
  background: #fff;
  .col-4 {
    padding: 0;
    height: 48px;
    line-height: 48px;
    text-align: center;
    &.c {
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
    }
    a {
      color: #434343;
      font-size: 14px;
      text-decoration: none;
      display: block;
    }
    .router-link-active {
      color: #fff;
      background-image: linear-gradient(73deg, #f36443, #e42029);
    }
  }
}
.search-time-con {
  padding: 0 15px;
  .l,
  .c,
  .r {
    display: inline-block;
    vertical-align: top;
  }
  .l {
    font-size: 14px;
    color: #434343;
  }
  .c {
    margin: 0 25px;
  }
}
.go-top {
  width: 40px;
  height: 40px;
  color: #fff;
  text-align: center;
  background-image: linear-gradient(73deg, #f36443, #e42029);
  border-radius: 50%;
  line-height: 40px;
  position: fixed;
  right: 20px;
  bottom: 60px;
  .iconfont {
    font-size: 10px;
    line-height: 40px;
    vertical-align: top;
  }
}
.des {
  font-size: 13px;
  color: #666;
  text-align: center;
  padding-top: 30px;
}
h3 {
  font-size: 18px;
  padding: 20px 0 16px 15px;
  color: #434343;
  margin-bottom: 0;
  font-weight: bold;
}
.top-con {
  input {
    font-size: 14px;
    background: red;
  }
  .r {
    padding-left: 0;
  }
  .button {
    width: 50px;
    height: 24px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    background-image: linear-gradient(73deg, #f36443, #e42029);
    border-radius: 4px;
    line-height: 24px;
  }
}
.tab {
  padding: 0 15px;
  .row > div {
    line-height: 1;
    padding: 15px;
  }
  .button {
    display: inline-block;
    font-size: 14px;
    padding: 0 10px;
    line-height: 24px;
    color: #434343;
    vertical-align: top;
    background: #eee;
    &.active {
      color: #fff;
      background-image: linear-gradient(73deg, #f36443, #e42029);
    }
  }
}
.content {
  border-top: 1px #ccc solid;
  margin: 0 15px;
  .list {
    padding: 0 10px;
    border-bottom: 1px #ccc solid;
    color: #434343;
    font-size: 14px;
    line-height: 20px;
  }
  .title {
    font-size: 16px;
    margin-bottom: 14px;
    color: #434343;
    padding-top: 14px;
    .icon-down {
      font-size: 10px;
      color: #434343;
      position: absolute;
      right: 24px;
    }
  }
  .list-con {
    border-top: 1px #ccc dashed;
    padding: 0 10px 10px 10px;
  }
  .sub-title {
    padding: 10px 0 10px;
  }
  .list-info {
    line-height: 18px;
    font-size: 13px;
  }
}
</style>